/**
 *
 * Unsubscribe/UnsubscribeUser
 *
 */

import React, { useState } from 'react'

// NPM Libraries
import { Link } from 'react-router-dom'
import axios from 'axios'

function UnsubscribeUser({ email_id, block_email, recipient_id }) {
	const [subscribed, setSubscribed] = useState(!block_email)
	const [submitting, setSubmitting] = useState(false)

	const notification_preferences_path = `/users/preferences/${recipient_id}#notifications`

	const updateUser = () => {
		setSubmitting(true)
		axios({
			method: 'PUT',
			url: `${process.env.API_URL}/api/v1/emails/settings/${email_id}/update_user`,
			data: {
				subscribed_to_email: !subscribed,
			},
		})
			.then((response) => {
				setSubmitting(false)
				if (response.status === 200) {
					setSubscribed(response.data.user.subscribed_to_email)
				}
			})
			.catch((error) => {
				setSubmitting(false)
				throw error
			})
	}

	return (
		<div className="mx-4 mt-3">
			<h5>LeadJig Notifications</h5>
			<p>
				Don't miss anything important!{' '}
				<Link to={notification_preferences_path}>Visit your notification preferences</Link> to choose which
				notifications you receive by email.
				<br />
				You are currently <strong>{subscribed ? 'subscribed' : 'unsubscribed'}</strong>.
			</p>
			<button type="button" className="btn btn-primary rounded" onClick={updateUser} disabled={submitting}>
				{subscribed ? 'Unsubscribe from all LeadJig notifications' : 'Subscribe'}
			</button>
		</div>
	)
}

UnsubscribeUser.propTypes = {}

export default UnsubscribeUser
